import { DefaultSeoProps } from 'next-seo'

export const SEO: DefaultSeoProps = {
  titleTemplate: '%s | AlchemyVault',
  defaultTitle: 'AlchemyVault',
  description: 'Trade, earn, and own crypto on the DEX',
  twitter: {
    cardType: 'summary_large_image',
    handle: '@AlchemyVault',
    site: '@AlchemyVault',
  },
  openGraph: {
    title: "🥞 AlchemyVault - Everyone's Favorite DEX",
    description: 'Trade, earn, and own crypto on the DEX',
    images: [{ url: 'https://assets.pancakeswap.finance/web/og/v2/hero.jpg' }],
  },
}
